<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2023-12-29 17:43:41
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\traceability\components\detail.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="65%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content:space-between;">
      <div>
        DI信息
      </div>
      <div>
        <el-button plain @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <DITable :page-list-data="pageListData" :height-style-obj="heightStyleObj" :dict-obj="dictObj" :search-param="searchParam"></DITable>
    <pagination v-show="total > 0" :total="total" :page-sizes="[10, 20, 50, 100]" :page.sync="searchParam.pageNum"
      :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
  </el-drawer>
</template>

<script>
import { getTraceabilityData } from '@/api/trace'
import DITable from './DITable'

export default {
  name: 'Detail',
  components: { DITable },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },

    dictObj: {
      type: Object,
      default() {
        return {
          delivery_status: [],
          operation_type: []
        }
      }
    },
    orderInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      pageListData: [],
      searchParam: {
        pageNum: 1,
        pageSize: 10,
      },
      heightStyleObj:0,
      total: 0,
    }
  },
  created() {
    this.$nextTick(() => {
      this.heightStyleObj = window.innerHeight - 325 + 'px'
    })
    this.getPageListData()

  },
  // 方法集合
  methods: {
    // 获取详细udi数据
    getPageListData() {
      const params = { ...this.searchParam }
      params.orderId = this.orderInfo.orderId
      params.productCode = this.orderInfo.productCode
      this.loading = true
      getTraceabilityData(params).then(res => {
        this.pageListData = res.rows
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },

  }
}
</script>
